import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { useAuth } from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { CartContext } from "../CartContext";
import { useTranslation } from "react-i18next";

const UserAccount = () => {
  const { currentUser, logout } = useAuth();
  const [popUp, setPopup] = useState(false);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const cart = useContext(CartContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.title = "Llogaria | Premium Perfume KS";
  }, []);

  useEffect(() => {
    if (currentUser) {
      const fetchOrders = async () => {
        try {
          const ordersQuery = query(
            collection(db, "orders"),
            where("userId", "==", currentUser.uid)
          );
          const querySnapshot = await getDocs(ordersQuery);
          const ordersList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          // Sort by timestamp descending
          ordersList.sort((a, b) => {
            const dateA = a.timestamp?.toDate ? a.timestamp.toDate() : new Date(a.timestamp);
            const dateB = b.timestamp?.toDate ? b.timestamp.toDate() : new Date(b.timestamp);
            return dateB - dateA;
          });
          setOrders(ordersList);
        } catch (error) {
          console.error("Error fetching orders: ", error);
        } finally {
          setLoading(false);
        }
      };
      fetchOrders();
    }
  }, [currentUser]);

  const handleReorder = (order) => {
    if (!order.items || order.items.length === 0) return;
    order.items.forEach((item) => {
      for (let i = 0; i < item.quantity; i++) {
        cart.addOneToCart(item.id, item.size);
      }
    });
    navigate("/checkout");
  };

  return (
    <Container>
      {currentUser && currentUser.email && (
        <h2 className="acc">
          {t("accountSignedAs")} <span>{currentUser.email}</span>
        </h2>
      )}

      {currentUser.email === "premiumperfumeks@gmail.com" && (
        <div className="menus">
          <Link to={"/admin/add-product"} className="link-styles">
            <button>ADD A PRODUCT</button>
          </Link>
          <Link to={"/admin/products"} className="link-styles">
            <button>PRODUCTS</button>
          </Link>
          <Link to={"/admin/orders"} className="link-styles">
            <button>ORDERS</button>
          </Link>
        </div>
      )}

      <button className="accBtn" onClick={() => setPopup(true)}>
        {t("accountLogout")}
      </button>
      {popUp && (
        <div className="popup">
          <p>{t("accountLogoutConfirm")}</p>
          <div className="btns">
            <button onClick={logout}>{t("accountYes")}</button>
            <button onClick={() => setPopup(false)}>{t("accountNo")}</button>
          </div>
        </div>
      )}

      <h2 className="section-title">{t("accountOrderHistory")}</h2>
      {loading ? (
        <p className="center">{t("accountLoading")}</p>
      ) : orders.length > 0 ? (
        <div className="orders">
          {orders.map((order) => (
            <div className="order-card" key={order.id}>
              <div className="order-header">
                <p>
                  {order.timestamp?.toDate
                    ? order.timestamp.toDate().toLocaleDateString()
                    : new Date(order.timestamp).toLocaleDateString()}
                </p>
                <p className="total">{order.totalPrice}€</p>
              </div>
              <div className="order-items">
                {order.items && order.items.map((item, idx) => (
                  <div className="order-item" key={idx}>
                    {item.image && <img src={item.image} alt={item.name} />}
                    <div>
                      <h4>{item.name}</h4>
                      <p>{item.size} × {item.quantity}</p>
                    </div>
                  </div>
                ))}
                {!order.items && <p className="legacy">{order.productDetails}</p>}
              </div>
              {order.items && order.items.length > 0 && (
                <button className="reorder-btn" onClick={() => handleReorder(order)}>
                  {t("accountReorder")}
                </button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="center">{t("accountNoOrders")}</p>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 6em 7%;
  .center {
    text-align: center;
    color: #aaa;
  }
  .section-title {
    text-align: center;
    font-family: "Comfortaa", sans-serif;
    font-weight: 200;
    font-size: 1.8em;
    margin-top: 2em;
    margin-bottom: 1em;
  }
  .menus {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0;
    flex-wrap: wrap;
    button {
      margin-top: 10px;
      margin-bottom: 10px;
      background: #303030;
      color: white;
      border-radius: 0;
    }
  }
  button {
    margin: auto;
    display: flex;
    margin-top: 1em;
    background: white;
    font-family: "Comfortaa", sans-serif;
    padding: 12px 20px;
    border: none;
    border-radius: 30px;
    font-size: 16px;
    cursor: pointer;
    transition: 0.4s;
    &:hover {
      background: var(--primaryColor);
      color: white;
    }
  }
  .popup {
    text-align: center;
    margin: auto;
    position: fixed;
    width: 400px;
    box-shadow: 0 0 13px 2px #1d1d1d;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 30px;
    background: #303030;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 999;
    .btns {
      display: flex;
      gap: 7px;
      button {
        margin-top: 1em;
        font-size: 17px;
        background: #e48888;
        color: var(--primaryBackgroundColor);
        padding: 10px 17px;
        border: none;
        cursor: pointer;
        &:nth-child(2) {
          background-color: #92f092;
        }
      }
    }
  }
  .acc {
    text-align: center;
    margin-top: 2em;
    font-weight: 400;
    color: #999;
    span {
      color: var(--fontPrimaryColor);
    }
  }
  .accBtn {
    display: flex;
    margin: auto;
    margin-top: 1em;
    font-size: 17px;
    background: #e48888;
    color: var(--primaryBackgroundColor);
    padding: 14px 17px;
    border: none;
    cursor: pointer;
  }
  .orders {
    display: flex;
    flex-direction: column;
    gap: 1.5em;
    max-width: 700px;
    margin: auto;
    .order-card {
      background: #2a2a2a;
      border-radius: 12px;
      padding: 1.5em;
      border: 1px solid #444;
      .order-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1em;
        p {
          color: #aaa;
          font-size: 14px;
        }
        .total {
          font-size: 18px;
          font-weight: 500;
          color: white;
        }
      }
      .order-items {
        display: flex;
        flex-direction: column;
        gap: 10px;
        .order-item {
          display: flex;
          align-items: center;
          gap: 10px;
          img {
            width: 50px;
            height: 50px;
            object-fit: contain;
            border-radius: 6px;
          }
          div {
            h4 {
              font-weight: 400;
              font-size: 15px;
              color: #ddd;
            }
            p {
              font-size: 13px;
              color: #999;
            }
          }
        }
        .legacy {
          white-space: pre-wrap;
          color: #999;
          font-size: 14px;
        }
      }
      .reorder-btn {
        margin-top: 1em;
        background: var(--primaryColor);
        color: white;
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 20px;
        &:hover {
          background: #a08060;
        }
      }
    }
  }
  @media (max-width: 500px) {
    padding: 6em 4%;
    .popup {
      width: 90%;
    }
  }
`;

export default UserAccount;
